import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setContractHistoryLogsLoading,
    getContractHistoryLogs,
    setContractHistoryPageSize,
    resetContractHistory,
    setContractHistoryColSearchStr
} from '../../../../constants/model-reducers/external/finance/contract/contract-details-history.settings';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
//import Moment from 'moment';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const contractHistoryActions = {
    getContractHistoryLogs: (contractID, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().contractHistory.HistoryTable;
        var formData = {
            ContractID: contractID,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
            //TimeZone: getLocalTimeZone()
        };

        dispatch({
            type: setContractHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost("external/finance/getContractHistoryLogs", formData);

        dispatch({
            type: getContractHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },
    setContractHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().contractHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setContractHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resizeContractHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setContractHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    extractContractHistoryLogs: (contractID) => async (dispatch, state) => {
        const { Headers } = state().contractHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM ${dealName} Contract History –  ${formattedTimeZoneDate}`;

        var formData = {
            ContractID: contractID,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/finance/getExtractContractHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },


    resetContractHistory: () => (dispatch, state) => {
        dispatch({
            type: resetContractHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setContractHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getContractHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setContractHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setContractHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetContractHistory:
            return initialState;
        default:
            return state;
    }
}